/**
 * SidePanelBar — Icon bar on chat edge, each icon opens its own window
 * Twin, Brain Wiki, Training always highlighted (active/on by default)
 */
import { Brain, CheckSquare, Dna, GraduationCap, MessageSquare, Wrench, Zap } from 'lucide-react'

const ICONS = [
  { icon: CheckSquare,   label: 'Tasks',      color: '#6366f1', windowId: 'task-manager',   alwaysOn: false },
  { icon: MessageSquare, label: 'FlzHub',     color: '#f59e0b', windowId: 'flzhub',          alwaysOn: false },
  { icon: Wrench,        label: 'Work',       color: '#10b981', windowId: 'research-window', alwaysOn: false },
  { icon: Zap,           label: 'Skills',     color: '#ec4899', windowId: 'store',           alwaysOn: false },
  { icon: Brain,         label: 'Brain Wiki', color: '#3b82f6', windowId: 'neural-brain',    alwaysOn: true  },
  { icon: GraduationCap, label: 'Training',   color: '#22c55e', windowId: 'training',        alwaysOn: true  },
  { icon: Dna,           label: 'Twin',       color: '#a855f7', windowId: 'twin',            alwaysOn: true  },
]

interface Props {
  chatPosition?: string
  panelWidth?: number
  chatTop?: number
  chatBottom?: number
  chatRight?: number
  chatLeft?: number
  chatWidth?: number
}

export default function SidePanelBar({ chatPosition = 'right' }: Props) {
  const open = (windowId: string) => {
    window.dispatchEvent(new CustomEvent('runai:open-window', { detail: windowId }))
  }

  return (
    <div style={{
      width: 36, display: 'flex', flexDirection: 'column',
      alignItems: 'center', paddingTop: 8, gap: 4, flexShrink: 0,
      borderLeft: chatPosition === 'right' ? '1px solid var(--os-border)' : 'none',
      borderRight: chatPosition === 'left' ? '1px solid var(--os-border)' : 'none',
      background: 'var(--os-surface)',
    }}>
      {ICONS.map(({ icon: Icon, label, color, windowId, alwaysOn }) => (
        <button
          key={windowId}
          onClick={() => open(windowId)}
          title={label}
          style={{
            width: 28, height: 28, borderRadius: 6, border: 'none',
            background: alwaysOn ? `${color}22` : 'transparent',
            color: alwaysOn ? color : 'var(--os-muted)',
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'all 0.15s',
            boxShadow: alwaysOn ? `0 0 0 1px ${color}44` : 'none',
          }}
          onMouseEnter={e => {
            const el = e.currentTarget as HTMLElement
            el.style.background = `${color}22`
            el.style.color = color
            el.style.boxShadow = `0 0 0 1px ${color}44`
          }}
          onMouseLeave={e => {
            const el = e.currentTarget as HTMLElement
            el.style.background = alwaysOn ? `${color}22` : 'transparent'
            el.style.color = alwaysOn ? color : 'var(--os-muted)'
            el.style.boxShadow = alwaysOn ? `0 0 0 1px ${color}44` : 'none'
          }}
        >
          <Icon size={14} />
        </button>
      ))}
    </div>
  )
}
